import { render, staticRenderFns } from "./DynamicTimeSpan.vue?vue&type=template&id=58a72e5d&scoped=true&"
import script from "./DynamicTimeSpan.vue?vue&type=script&lang=js&"
export * from "./DynamicTimeSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a72e5d",
  null
  
)

export default component.exports